import Vue from "vue";
import dayjs from 'dayjs';
Vue.filter("subStr", function (str, count = 2, returnDots = false) {
  if (!str) return "";
  return str.substr(0, count) + (returnDots && str.length > count ? "..." : "");
});

Vue.filter('formatDate', (date) => {
  return date ? dayjs(date).format('DD/MM/YYYY') : date;
});
Vue.filter('fileExtension', (fileName) => {
  return  fileName.split('.').pop();
});